import { useTranslate } from 'src/shared/providers';

export const useLocalizedJobNames = (levels?: number) => {
  const { t } = useTranslate();

  const localizedJobNames = [
    t('global.job1'),
    t('global.job2'),
    t('global.job3'),
    t('global.job4'),
    t('global.job5'),
    t('global.job6'),
  ];

  return levels ? localizedJobNames.slice(0, levels) : localizedJobNames;
};
